import image1 from './landscape portfolio/1.jpg';
import image2 from './landscape portfolio/2.jpg';
import image3 from './landscape portfolio/3.jpg';
import image4 from './landscape portfolio/4.jpg';
import image5 from './landscape portfolio/5.jpg';
import image6 from './landscape portfolio/6.jpg';
import image7 from './landscape portfolio/7.jpg';
import image8 from './landscape portfolio/8.jpg';
// Removed duplicate image imports

// Store images in an array
const landscapePortfolio = [
  image1, image2, image3, image4, image5, image6, image7, image8,
];

// Export the array
export default landscapePortfolio;
